import React, { useState, useEffect,useRef } from "react";
import GetMonthsOpt from "../Dropdowns/getSelectMonth.js";
import GetYearsOpt from "../Dropdowns/getSelectYear.js";
import FPSBankStatementGenerateLink from "./FPSBankStatementGenerateLink.jsx";
import GenericDropdown from "../Dropdowns/GenericDropdown.js";
import CircularProgress from '@mui/material/CircularProgress'; 
import Box from '@mui/material/Box'; 

const FPSCommissionSummaryDownload = ({
  month,
  year,
  allotMonth,
  allotYear,
  distCode,
  distMonthName,
  alotMonthName,
  districtName,
  userName,
  action,
}) => {
  const [loading, setLoading] = useState(true);
  const [generateBankData, setGenerateBankData] = useState([]);
  const [error, setError] = useState(null);
  const [showMessageData, setShowMessageData] = useState({
    status: "",
    message: "",
  });

  const [selectedDistCode, setSelectedDistCode] = useState("");
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [renderContent, setRenderContent] = useState(null);
  const [bankType, setBankType] = useState("DCR");
  const hasFetched = useRef(false);
  const [trigger, setTrigger] = useState(0);


  const bankTypeNames = {
    DCR: "DCR",
    NEFT: "NEFT",
  };

  const generateBankStatement = async () => {
      try {
        setLoading(true);
        const queryParams = new URLSearchParams({
          month,
          year,
          allotMonth,
          allotYear,
          distCode,
          distMonthName,
          alotMonthName,
          districtName,
          userName,
        });

      let endpoint = "";

      if (action === "generate") {
        endpoint = "generate-bank-statement";
      } else if (action === "regenerate") {
        endpoint = "regenerate-bank-statement";
      } else {
        return; 
      }

      const response = await fetch(
        `${process.env.REACT_APP_URL}/api/commission/${endpoint}?${queryParams}`
      );

      if (!response.ok) {
        throw new Error(`Failed to ${action} bank statement`);
      }

      const data = await response.json();      
      setShowMessageData(data);
      } catch (error) {
        console.error("Fetch Error:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

//   useEffect(() => {
//   //if (!hasFetched.current && action && month && year) {
//     hasFetched.current = false;
//     //generateBankStatement();
//   //}
// }, [action, month, year, allotMonth, allotYear, distCode]);


useEffect(() => {
  if (action && month && year && allotMonth && allotYear && distCode) {
    generateBankStatement();
  }
}, [action, month, year, allotMonth, allotYear, distCode]);

 

  const handleMonthsLoadingChange = (isLoading) => {
    handleLoadingChange(isLoading);
  };

  const handleLoadingChange = (isLoading) => {
    setLoading(isLoading);
  };

  const handleYearsLoadingChange = (isLoading) => {
    handleLoadingChange(isLoading);
  };

  const handleDistrictChange = (dist_code) => {
    setSelectedDistCode(dist_code);
  };

  const handleChange = (e) => {};

  const handleSubmit = async (action) => {
    const month = document.getElementById("months").value;
    const year = document.getElementById("years").value;
    const allot_month = document.getElementById("allot_months").value;
    const allot_year = document.getElementById("allot_years").value;
    const distCode = document.getElementById("dist_id").value;
    const distMonthName =
      document.getElementById("months").options[
        document.getElementById("months").selectedIndex
      ].text;
    const alotMonthName =
      document.getElementById("allot_months").options[
        document.getElementById("allot_months").selectedIndex
      ].text;
    const districtName =
      document.getElementById("dist_id").options[
        document.getElementById("dist_id").selectedIndex
      ].text;
    const bankDisplay = bankTypeNames[bankType] || "";

    if (month == null || month == "") {
      alert("Please select Distribution Month");
      return false;
    } else if (year == null || year == "") {
      alert("Please select Distribution Year");
      return false;
    }
    else if (allot_month == null || allot_month == "") {
      alert("Please select Allotment Month");
      return false;
    } else if (allot_year == null || allot_year == "") {
      alert("Please select Allotment Year");
      return false;
    } else if (distCode == null || distCode == "") {
      alert("Please select District");
      return false;
    } else {
      setRenderContent(null);
      setRenderContent(
        <FPSBankStatementGenerateLink
          key={`${action}-${trigger}`} 
          month={month}
          year={year}
          allotMonth={allot_month}
          allotYear={allot_year}
          distCode={distCode}
          distMonthName={distMonthName}
          alotMonthName={alotMonthName}
          districtName={districtName}
          bankDisplay={bankType}
          action = {action}
        />
      );

      setTrigger(prev => prev + 1); 
    }
  };

  if (loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Box sx={{ display: 'flex' }}>
            <CircularProgress />
          </Box>
        </div>
      );
    }
  

  return (
    <>
      {showMessageData?.message && (
        <div
          className="mainhead"
          align="center"
          style={{
            marginTop: "1px",
            marginBottom: "20px",
            textDecoration: "none",
          }}
        >
          {showMessageData.message}
        </div>
      )}
      {/* Only show form when API status is Success */}
      {showMessageData?.status === "Success" && (
        <>
          <div className="wrapper row3" style={{ maxHeight: "95vh" }}></div>

          <div id="container" style={{ marginLeft: "200px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "0px",
              }}
            ></div>

            <table width="85%">
              <thead>
                <tr className="tableheader">
                  <th colSpan={12}>Download Bank Statement for State</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Distribution Month :</td>
                  <td>
                    <GetMonthsOpt
                      input_id="months"
                      onLoadingChange={handleMonthsLoadingChange}
                    />
                  </td>

                  <td>Distribution Year :</td>
                  <td>
                    <GetYearsOpt
                      input_id="years"
                      onLoadingChange={handleYearsLoadingChange}
                    />
                  </td>

                  <td>Allotted Month :</td>
                  <td>
                    <GetMonthsOpt
                      input_id="allot_months"
                      onLoadingChange={handleMonthsLoadingChange}
                    />
                  </td>

                  <td>Allotted Year :</td>
                  <td>
                    <GetYearsOpt
                      input_id="allot_years"
                      onLoadingChange={handleYearsLoadingChange}
                    />
                  </td>

                  <td>District :</td>
                  <td>
                    <GenericDropdown
                      tab="common.district_master"
                      code="dist_code"
                      name="dist_name_en"
                      whfld=""
                      whval=""
                      whfld1=""
                      whval1=""
                      dropdownName="dist_name"
                      dropdownId="dist_id"
                      JSONKey="id"
                      JSONValue="name"
                      onChange={handleChange}
                    />
                  </td>
                  <td>Type</td>
                  <td>
                    <select
                      name="bankType"
                      id="bankType"
                      value={bankType}
                      onChange={(e) => setBankType(e.target.value)}
                    >
                      <option value="DCR">DCR</option>
                      <option value="NEFT">NEFT</option>
                    </select>
                  </td>
                </tr>

                <tr>
                  <td colSpan="12" align="center">

                    <button
                      className="button button2"
                      style={{ marginRight: "10px" }}
                      onClick={() => handleSubmit(action)}
                    >
                      {action === "generate"
                        ? "Generate Link"
                        : "Regenerate Link"}
                    </button>

                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <div id="loading" style={{ display: "none", textAlign: "center" }}>
              <img src="images/progress.gif" alt="Loading" />
            </div>
            <br />
            <div id="fpsBankStatementGenerateLinkId">{renderContent}</div>
          </div>
        </>
      )}
    </>
  );
};

export default FPSCommissionSummaryDownload;
